<template>
  <div :class="['column summary-column equal-height', { 'max-280' : isBillingSection}]">
    <h2 class="summary">Summary</h2>
    <h6 class="Plan" v-text="getPlanText"></h6>
    <h6 v-if="isBillingSection" class="Plan is-hidden-desktop" v-text="getPlanNameAndFrequency"></h6>
    <p class="has-text-left" v-if="purchaseTypeIsPlan" v-text="getPlanName"></p>
    <p class="has-text-left" v-if="purchaseTypeIsPlan" v-html="getPlanSummaryBody"></p>
    <p class="has-text-left" v-if="!purchaseTypeIsPlan" v-html="getAddOnSummaryBody"></p>
    <h6 v-if="!isFreePlan && purchaseTypeIsPlan" :class="['Plan', { 'force-hide-billing-mobile' : isBillingSection}]">Billing cycle</h6>
    <p v-if="!isFreePlan && purchaseTypeIsPlan" class="has-text-left cycle" v-text="getBillingFrequency"></p>
    <h6 v-if="!isFreePlan" :class="['Plan price-header', { 'is-addon-invoice' : isAddOnInvoice }, { 'force-hide-billing-mobile' : isBillingSection}]">Price</h6>
    <template v-if="qualifiesForBlackFridayDiscount">
      <!-- ANNUAL GROWTH SECTION 1 -->
      <div v-if="!isFreePlan && isAnnualPlan && purchaseTypeIsPlan" class="columns is-marginless is-mobile">
        <p class="column has-text-left is-two-thirds descriptions">Amount excl. VAT<br/><span class="discount" v-html="getAnnualDiscountPercentage"></span></p>
        <p class="column has-text-left values">{{ getAnnualDiscountAmountExVatExDiscount }}<br/><span class="discount" v-html="getAnnualDiscountAmount"></span></p>
      </div>
      <!-- ANNUAL GROWTH SECTION 2 -->
      <div v-if="!isFreePlan && isAnnualPlan && purchaseTypeIsPlan" class="columns is-marginless is-mobile price-section">
        <p class="column has-text-left is-two-thirds descriptions">VAT<br/>Total amount to be paid</p>
        <p class="column has-text-left values" v-html="getAnnualVatAndTotal"></p>
      </div>
      <!-- MONTHLY GROWTH OR ANNUAL PREMIUM PAID -->
      <div v-if="!isFreePlan && (!isAnnualPlan && isGrowthPlan) || isAddOnInvoice" class="columns is-marginless is-mobile price-section">
        <p class="column has-text-left is-two-thirds-desktop descriptions no-border">Amount excl. VAT<br/>VAT<br/>Total amount to be paid</p>
        <p class="column has-text-left-tablet has-text-right-mobile values no-border" v-html="getMonthlyCostVatTotal"></p>
      </div>
    </template>
    <template v-if="!qualifiesForBlackFridayDiscount">
      <!-- ANNUAL GROWTH SECTION 1 -->
      <div v-if="!isFreePlan && isAnnualPlan && isGrowthPlan && purchaseTypeIsPlan" class="columns is-marginless is-mobile">
        <p class="column has-text-left is-two-thirds descriptions">Amount excl. VAT<br/><span class="discount" v-html="getAnnualDiscountPercentage"></span></p>
        <p class="column has-text-left values">{{ getAnnualDiscountAmountExVatExDiscount }}<br/><span class="discount" v-html="getAnnualDiscountAmount"></span></p>
      </div>
      <!-- ANNUAL GROWTH SECTION 2 -->
      <div v-if="!isFreePlan && isAnnualPlan && isGrowthPlan && purchaseTypeIsPlan" class="columns is-marginless is-mobile price-section">
        <p class="column has-text-left is-two-thirds descriptions">VAT<br/>Total amount to be paid</p>
        <p class="column has-text-left values" v-html="getAnnualVatAndTotal"></p>
      </div>
      <!-- MONTHLY GROWTH OR ANNUAL PREMIUM PAID -->
      <div v-if="!isFreePlan && (!isAnnualPlan && isGrowthPlan) || (isAnnualPlan && isPremiumPlan) || isAddOnInvoice" class="columns is-marginless is-mobile price-section">
        <p class="column has-text-left is-two-thirds-desktop descriptions no-border">Amount excl. VAT<br/>VAT<br/>Total amount to be paid</p>
        <p class="column has-text-left-tablet has-text-right-mobile values no-border" v-html="getMonthlyCostVatTotal"></p>
      </div>
    </template>
    <p v-if="wantToKnowMore" class="has-text-left want-to-know-more">Want to know more?&nbsp;<a target="_blank" rel="nofollow" href="https://intercom.help/hellopeter/en/collections/2645584-hellopeter-plans-and-billing">Yes!</a></p>
    <button :disabled="isCheckoutPublishing || disableCheckout" @click.prevent="checkout" v-if="showCheckout" :class="['button', { 'is-loading' : isCheckoutPublishing }]">CHECKOUT</button>
  </div>
</template>
<script>
import Plans from './../mixins/plans.js'
import moment from 'moment'

export default {
  name: 'SummaryComponent',
  props: {
    name: {
      type: String,
      default: 'Free'
    },
    purchaseTypeIsPlan: {
      type: Boolean,
      default: true
    },
    qualifiesForBlackFridayDiscount: {
      type: Boolean,
      default: false
    },
    isOnboard: {
      type: Boolean,
      default: true
    },
    invitations: {
      type: Number,
      default: 0
    },
    reviews: {
      type: Number,
      default: 0
    },
    replies: {
      type: Number,
      default: 0
    },
    cycle: {
      type: String,
      default: 'Monthly'
    },
    priceExVat: {
      type: Number,
      default: 0
    },
    discountPercent: {
      type: Number,
      default: 0
    },
    vatPercent: {
      type: Number,
      default: 0.15
    },
    isBillingSection: {
      type: Boolean,
      default: false
    },
    isBillingEditSection: {
      type: Boolean,
      default: false
    },
    wantToKnowMore: {
      type: Boolean,
      default: true
    },
    showCheckout: {
      type: Boolean,
      default: false
    },
    checkoutUrl: {
      type: String,
      default: ''
    },
    isCheckoutPublishing: {
      type: Boolean,
      default: false
    },
    disableCheckout: {
      type: Boolean,
      default: false
    },
    invoiceDetail: {
      type: Object,
      default: undefined
    },
    isCurrentlyFree: {
      type: Boolean,
      default: false
    }
  },
  mixins: [Plans],
  methods: {
    checkout () {
      window.events.$emit('checkoutUpgrade')
    }
  },
  computed: {
    isFreePlan () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return false
      }
      return this.purchaseTypeIsPlan && this.name.toLowerCase() === 'free'
    },
    isAnnualPlan () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return this.invoiceDetail.subscriptionType.is_annually_paid === 1
      }
      return this.name.toLowerCase().startsWith('p') || this.cycle.toLowerCase() === 'annual'
    },
    isGrowthPlan () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return this.invoiceDetail.subscriptionType.name.indexOf('G') !== -1
      }
      const name = this.name.toLowerCase()
      return name.startsWith('g')
    },
    isPremiumPlan () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return this.invoiceDetail.subscriptionType.name.indexOf('P') !== -1
      }
      const name = this.name.toLowerCase()
      return name.startsWith('p')
    },
    getAnnualDiscountAmountExVatExDiscount () {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }

      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.amount_exc_vat !== 'undefined') {
        let priceExVat = parseFloat(this.invoiceDetail.amount_exc_vat.replace(' ', ''))
        const lineItems = JSON.parse(this.invoiceDetail.invoice.invoice_items)
        const discount = lineItems.find(x => x.code === 'ANNDISC')
        if (typeof discount !== 'undefined') {
          priceExVat -= parseFloat(discount.price)
        }
        priceExVat = formatter(priceExVat)
        return `R${priceExVat}`
      }

      const today = moment()
      const campaignEnd = moment('2023-11-30')

      const name = this.name.toLowerCase()
      const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
      const showBlackFridayPlan = !today.isAfter(campaignEnd) && cycle === 'annual' && this.qualifiesForBlackFridayDiscount
      const plan = showBlackFridayPlan ? this.blackFridayPlans[cycle][name] : this.plans[cycle][name]
      const priceExVat = formatter(this.priceExVat > 0 ? this.priceExVat : plan.cost)
      return `R${priceExVat}`
    },
    getAnnualDiscountPercentage () {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        if (this.invoiceDetail.invoice.created_for === 'SUBSCRIPTION') {
          const lineItems = JSON.parse(this.invoiceDetail.invoice.invoice_items)
          const price = lineItems.find(x => x.type === 'SUBSCRIPTION')
          const discount = lineItems.find(x => x.code === 'ANNDISC')
          if (typeof discount !== 'undefined' && typeof price !== 'undefined') {
            // const priceExVat = formatter(-discount.price)
            const discountPrint = Math.floor(formatter((-discount.price / price.price) * 100))
            return `Discount (${discountPrint}&#37;)`
          }
        }
      }
      let discountPercent = this.discountPercent > 0 ? this.discountPercent : 0.1
      const today = moment()
      const campaignEnd = moment('2023-11-30')
      let discountPrefix = 'Discount '
      if (!today.isAfter(campaignEnd)) {
        const name = this.name.toLowerCase()
        const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
        const showBlackFridayPlan = !today.isAfter(campaignEnd) && cycle === 'annual' && this.qualifiesForBlackFridayDiscount
        if (showBlackFridayPlan) {
          discountPercent = 0.3
          discountPrefix = 'Promo Discount '
        }
      }
      const discountRender = Math.floor(discountPercent * 100.0)
      return `${discountPrefix} (${discountRender}&#37;)`
    },
    getAnnualDiscountAmount () {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }

      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        if (this.invoiceDetail.invoice.created_for === 'SUBSCRIPTION') {
          const lineItems = JSON.parse(this.invoiceDetail.invoice.invoice_items)
          const discount = lineItems.find(x => x.code === 'ANNDISC')
          if (typeof discount !== 'undefined') {
            const priceExVat = formatter(-discount.price)
            return `R${priceExVat}`
          }
        }
        return 'R0.00'
      }

      const today = moment()
      const campaignEnd = moment('2023-11-30')

      const name = this.name.toLowerCase()
      const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
      const showBlackFridayPlan = !today.isAfter(campaignEnd) && cycle === 'annual' && this.qualifiesForBlackFridayDiscount
      const plan = showBlackFridayPlan ? this.blackFridayPlans[cycle][name] : this.plans[cycle][name]
      let priceExVat = this.priceExVat > 0 ? this.priceExVat : plan.cost
      let discountPercent = this.discountPercent > 0 ? this.discountPercent : 0.1

      // replace currentlyFree with greater than current sub
      if (showBlackFridayPlan) {
        discountPercent = 0.3
      }
      const discountAmount = formatter(discountPercent * priceExVat)
      return `R${discountAmount}`
    },
    isAvailableForBlackFriday () {
      const today = moment()
      const campaignEnd = moment('2023-11-30')
      return !today.isAfter(campaignEnd)
    },
    getAnnualVatAndTotal () {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }

      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.amount_inc_vat !== 'undefined') {
        const totalIncVat = formatter(parseFloat(this.invoiceDetail.amount_inc_vat.replace(' ', '')))
        const vatPercent = this.invoiceDetail.vat_percent_applied.replace('%', '')
        return `${vatPercent}&#37;<br/>R${totalIncVat}`
      }

      const today = moment()
      const campaignEnd = moment('2023-11-30')

      const vatPercent = this.vatPercent
      const name = this.name.toLowerCase()
      const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
      const showBlackFridayPlan = !today.isAfter(campaignEnd) && cycle === 'annual' && this.qualifiesForBlackFridayDiscount
      const plan = showBlackFridayPlan ? this.blackFridayPlans[cycle][name] : this.plans[cycle][name]
      let priceExVat = this.priceExVat > 0 ? this.priceExVat : plan.cost
      let discountPercent = this.discountPercent > 0 ? this.discountPercent : 0.1

      // replace free with greater than current sub
      if (showBlackFridayPlan) {
        if (cycle === 'annual') {
          discountPercent = 0.3
        }
      }
      const discountAmount = discountPercent * priceExVat
      priceExVat -= discountAmount
      const vatAmount = priceExVat * vatPercent
      const vatDisplayPercent = vatPercent * 100
      const priceIncVat = formatter(priceExVat + vatAmount)
      return `${vatDisplayPercent}&#37;<br/>R${priceIncVat}`
    },
    getMonthlyCostVatTotal () {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }

      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.amount_inc_vat !== 'undefined') {
        const totalExVat = formatter(parseFloat(this.invoiceDetail.amount_exc_vat.replace(' ', '')))
        const totalIncVat = formatter(parseFloat(this.invoiceDetail.amount_inc_vat.replace(' ', '')))
        const vatPercent = this.invoiceDetail.vat_percent_applied.replace('%', '')
        return `R${totalExVat}<br/>${vatPercent}&#37;<br/>R${totalIncVat}`
      }

      const vatPercent = this.vatPercent
      const name = this.name.toLowerCase()
      const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
      const plan = this.plans[cycle][name]
      let priceExVat = this.priceExVat > 0 ? this.priceExVat : plan.cost
      const priceExVatRender = formatter(priceExVat)
      const vatAmount = priceExVat * vatPercent
      const vatDisplayPercent = vatPercent * 100
      const priceIncVatRender = formatter(priceExVat + vatAmount)
      return `R${priceExVatRender}<br/>${vatDisplayPercent}&#37;<br/>R${priceIncVatRender}`
    },
    getPlanText () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        if (this.invoiceDetail.invoice.created_for !== 'SUBSCRIPTION') {
          return `Add-ons`
        }
      }
      return `Plan`
    },
    isAddOnInvoice () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        return this.invoiceDetail.invoice.created_for !== 'SUBSCRIPTION'
      }
      return false
    },
    getPlanName () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return this.invoiceDetail.subscriptionType.name.indexOf('G') !== -1 ? 'Growth' : 'Premium'
      }
      switch (this.name.toLowerCase()) {
        case 'g1':
        case 'g2':
        case 'g3':
        case 'g4':
          return `Growth`
        case 'free':
          return `Free`
        default:
          return `Premium`
      }
    },
    getPlanNameAndFrequency () {
      let planName = ''
      switch (this.name.toLowerCase()) {
        case 'g1':
        case 'g2':
        case 'g3':
        case 'g4':
          planName = `Growth`
          break
        case 'free':
          planName = `Free`
          break
        default:
          planName = `Premium`
          break
      }
      return `${planName} ${this.cycle.substr(0, 1).toUpperCase()}${this.cycle.substr(1).toLowerCase()}`
    },
    getAddOnSummaryBody () {
      if (typeof this.invoiceDetail !== 'undefined') {
        let ret = ''
        const lineItems = JSON.parse(this.invoiceDetail.invoice.invoice_items)
        const reviews = lineItems.find(x => x.name === 'Reviews')
        const invites = lineItems.find(x => x.name === 'Review Invites')
        if (typeof reviews !== 'undefined') {
          ret += `${reviews.qty} Review credits`
        }
        if (typeof invites !== 'undefined') {
          if (ret.length > 0) {
            ret += '<br/>'
          }
          ret += `${invites.qty} Review invitation credits`
        }
        return ret
      }
      return ''
    },
    getPlanSummaryBody () {
      if (typeof this.invoiceDetail === 'undefined') { // use mixin or external source to get pricing and quantities
        const today = moment()
        const campaignEnd = moment('2023-11-30')

        const name = this.name.toLowerCase()
        const cycle = (name.startsWith('p')) ? 'annual' : this.cycle.toLowerCase()
        const showBlackFridayPlan = !today.isAfter(campaignEnd) && cycle === 'annual' && this.qualifiesForBlackFridayDiscount
        const plan = showBlackFridayPlan ? this.blackFridayPlans[cycle][name] : this.plans[cycle][name]
        const replyCredits = (plan.replyCredits === 99999999) ? 'Unlimited' : plan.replyCredits
        const reviewCredits = (plan.reviewCredits === 99999999) ? 'Unlimited' : plan.reviewCredits
        const reviewInvites = (plan.reviewInvites === 99999999) ? 'Unlimited' : plan.reviewInvites
        const freq = cycle === 'annual' ? 'p.a.' : 'p.m.'
        let ret = `${reviewInvites} Review invitations ${freq}`
        if (plan.replyCredits > 0) {
          ret += `<br/>${replyCredits} Reply credits ${freq}`
        }
        if (plan.reviewCredits > 0) {
          ret += `<br/>${reviewCredits} Review credits ${freq}`
        }
        return ret
      }
      if (typeof this.invoiceDetail !== 'undefined') {
        let ret = ''
        const lineItems = JSON.parse(this.invoiceDetail.invoice.invoice_items)
        const subscription = lineItems.find(x => x.type === 'SUBSCRIPTION')
        if (typeof subscription !== 'undefined') {
          // subscription/plan
          const cycle = subscription.name.indexOf('Annual') !== -1 ? 'annual' : 'monthly'
          const reviews = lineItems.find(x => x.type === 'IN_BUNDLE' && x.name === 'Reviews')
          const invites = lineItems.find(x => x.type === 'IN_BUNDLE' && x.name === 'Review Invites')
          const replyCredits = (reviews.qty === 999999999) ? 'Unlimited' : reviews.qty
          const reviewCredits = (reviews.qty === 999999999) ? 'Unlimited' : reviews.qty
          const reviewInvites = (invites.qty === 999999999) ? 'Unlimited' : invites.qty
          const freq = cycle === 'annual' ? 'p.a.' : 'p.m.'
          ret = `${reviewInvites} Review invitations ${freq}`
          ret += `<br/>${replyCredits} Reply credits ${freq}`
          ret += `<br/>${reviewCredits} Review credits ${freq}`
        } else {
          // add-ons
        }
        return ret
      }
      // return `20 Review invitations p.m.<br/>3 Reply credits p.m.`
      return `Unknown`
    },
    getBillingFrequency () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.subscriptionType !== 'undefined') {
        return this.invoiceDetail.subscriptionType.is_annually_paid === 1 ? 'Annual' : 'Monthly'
      }
      if (this.name.toLowerCase() === 'free') {
        return `Monthly`
      }
      if (this.name.toLowerCase().startsWith('p')) {
        return `Annual`
      } else {
        return `${this.cycle.substr(0, 1).toUpperCase()}${this.cycle.substr(1).toLowerCase()}`
      }
    }
  }
}
</script>
<style scoped>
.summary {
  font-family: Montserrat;
  margin-top: 40px;
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: left;
  color: #1261a0;
}

.summary-column {
  border-left: solid 1px rgba(112, 112, 112, 0.12);
}

.columns {
  margin-top: 0;
}
.columns:last-child {
  margin-bottom: 0;
}

.Plan {
  margin-top: 30px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}



.summary-column > .Plan.price-header {
  margin-top: 20px;
}



.Plan + p {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.Plan + p + p {
  margin-top: 5px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}



.columns .want-to-know-more {
  margin-top: auto;
}

.button {
  background-color: #1261a0;
  font-family: 'Open Sans';
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  width: 180px;
  height: 35px;
  padding: 10px 61px;
  border-radius: 2px;
  /*position: relative;*/
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  display: block;
}

.cycle {
  border-bottom: solid 1px rgba(112, 112, 112, 0.12);
  padding-bottom: 20px;
}

.Plan + .columns > p, .Plan + .columns + .columns > p {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  padding-left: 0;
  color: #58595b;
}



.values {
  padding-left: 0!important;
}

.descriptions {
  padding-right: 0!important;
}

.discount {
  font-size: 14px;
  color: #17bd85;
}



.price-section > p {
  border-top: solid 1px rgba(112, 112, 112, 0.12);
}



.no-border {
  border: none!important;
  padding-top: 6px;
}

.summary-column > .Plan.price-header.is-addon-invoice {
  margin-top: 150px;
  padding-top: 25px;
  border-top: solid 1px rgba(112, 112, 112, 0.12);
}

@media screen and (min-width: 768px) {
  .max-280 {
    max-width: 280px;
    padding-top: 20px;
  }

  .max-280 > .summary {
    margin-top: 0;
    font-size: 14px;
    text-align: left;
  }

  .max-280 > .Plan {
    font-size: 12px;
    margin-top: 10px;
  }

  .summary-column.max-280 > .Plan.price-header {
    margin-top: 25px;
  }

  .max-280 > .Plan + p {
    font-size: 12px;
    margin-top: 5px;
  }

  .max-280 > .Plan + p + p {
    font-size: 12px;
  }

  .max-280 > .Plan + p + p + .Plan {
    margin-top: 20px;
  }

  .max-280 > .Plan + .columns > p, .Plan + .columns + .columns > p {
    font-size: 12px;
    padding-top: 6px;
  }

  .max-280 .discount {
    font-size: 12px;
  }

  .max-280 > .price-section > p {
    font-size: 12px;
  }
}

@media screen and (max-width: 767px) {
  .summary {
    border-top: solid 1px rgba(112, 112, 112, 0.12);
    margin-top: 25px!important;
    padding-top: 23px;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #1261a0;
  }

  .max-280 > .summary {
    text-align: left;
  }

  .summary-column {
    margin-top: 0!important;
    padding-top: 0;
  }

  .Plan {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    margin-bottom: 8px;
  }

  .Plan + p {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .want-to-know-more {
    font-family: OpenSans;
    font-size: 14px!important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36!important;
    letter-spacing: normal;
    text-align: center!important;
    color: #58595b;
    margin-top: 42px!important;
  }

  p.want-to-know-more {
    font-family: Open Sans;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  p.want-to-know-more > a, p.want-to-know-more > a:hover, p.want-to-know-more > a:visited {
    color: #30aae1;
    text-decoration: underline;
  }

  .Plan + .columns > p, .Plan + .columns + .columns > p {
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    margin: 0;
  }

  .summary-column.max-280 {
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 40px;
  }

  /**
   * Billing section only for is-mobile
   */
  .column.summary-column.equal-height.max-280 {
    margin: 0;
  }

  .column.summary-column.equal-height.max-280 > .summary {
    display: none;
  }

  .column.summary-column.equal-height.max-280 > .summary + .Plan {
    display: none;
  }

  .column.summary-column.equal-height.max-280 > .has-text-left {
    display: none;
  }

  .column.summary-column.equal-height.max-280 > .force-hide-billing-mobile {
    display: none;
  }

  .summary-column {
    border: none;
  }

  /* .column.summary-column.equal-height.max-280 > .summary + .Plan + .Plan { */
  /*   display: none; */
  /* } */

}
</style>



// WEBPACK FOOTER //
// src/components/Summary.vue